export default "__VITE_ASSET__BaahGnKt__"